import { differenceInDays } from 'date-fns'

import { Offer } from '@wwt/entities/search-response'

import { assert } from '@/shared/lib/assert'

export const getOfferDuration = (offer: {
	roomDynamic: Pick<Offer['roomDynamic'], 'checkIn' | 'checkOut'>
}) => {
	const checkIn = offer.roomDynamic.checkIn
	const checkOut = offer.roomDynamic.checkOut

	const checkInDate = new Date(checkIn ?? '1900-01-01')
	const checkOutDate = new Date(checkOut ?? '1900-01-01')

	assert(Boolean(checkIn), 'Check-in date is invalid on get offer duration')
	assert(Boolean(checkOut), 'Check-out date is invalid on get offer duration')

	return differenceInDays(checkOutDate, checkInDate)
}
